import React, { useState } from "react";
// import { slides, text } from "../translations/spanish";
import { slides, text } from "../translations/english";

const Arrow = ({ direction, clickFunction, glyph, text }) => (
  <button className={`slide-arrow   ${direction}`} onClick={clickFunction}>
    {text && <p className="slide-arrow-text">{text}</p>}
    <div className="slide-arrow-icon">{glyph}</div>
  </button>
);

const dayOfMonth = new Date().getDate();
// const dayOfMonth = 11;

const slideOfTheDay = dayOfMonth > 25 ? 25 : dayOfMonth;

slides.length = slideOfTheDay + 1;

const Carousel = ({ index = slideOfTheDay }) => {
  const [currentSlide, setCurrentSlide] = useState(index);
  // const [, setLoadedSlide] = useState(false);

  const { title, img, content, pdf } = slides[currentSlide];

  const isCover = !(title && content);

  const goPreviousSlide = () => {
    const lastIndex = slides.length - 1;

    const shouldResetIndex = currentSlide === 0;
    const index = shouldResetIndex ? lastIndex : currentSlide - 1;
    // setPreviousSlide(currentSlide);
    setCurrentSlide(index);
  };

  const goNextSlide = () => {
    const lastIndex = slides.length - 1;
    const shouldResetIndex = currentSlide === lastIndex;
    const index = shouldResetIndex ? 0 : currentSlide + 1;
    // setPreviousSlide(currentSlide);

    setCurrentSlide(index);
  };

  return (
    <div>
      <div className="carousel">
        {isCover ? (
          <div className="slide slide-cover">
            <img src={img} alt="" />
          </div>
        ) : (
          <div className={"slide "}>
            <div className="slide-content">
              <h3 className="slide-title">
                {text.chapter} {currentSlide}
              </h3>
              <img src={img} alt="" />
              <h5 className="slide-subtitle">{title}</h5>
              <div
                className="slide-text"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>
              {pdf && (
                <a
                  className="slide-farmlink"
                  target="_blank"
                  rel="noreferrer"
                  href={pdf}
                >
                  <i className="far fa-file-pdf"></i> {text.pdfBlurb}
                </a>
              )}

              <img
                className="slide-watermark"
                alt=""
                src="https://images.ctfassets.net/qx1dg9syx02d/1GWXk3Hi5qAek0oj8db5DY/8a85be48fb885e347fda486b1af4818f/Small-Botannical.png"
              />
            </div>
          </div>
        )}

        <Arrow
          direction="left"
          text={<span>{text.previousBtn}</span>}
          clickFunction={goPreviousSlide}
          glyph={<i className="fas fa-chevron-left"></i>}
        />

        <Arrow
          direction="right"
          text={<span>{text.nextBtn}</span>}
          clickFunction={goNextSlide}
          glyph={<i className="fas fa-chevron-right"></i>}
        />
      </div>
      <div
        className=""
        style={{
          display: "flex",
          justifyContent: "center",
          fontSize: 14,
          alignItems: "baseline",
        }}
      >
        <span>{text.skipChapter} &nbsp;</span>
        <select
          className="slideshow-select"
          onChange={(e) => {
            setCurrentSlide(parseInt(e.target.value));
          }}
          value={currentSlide}
        >
          {slides.map((slide, i) => {
            return (
              <option key={i} value={i}>
                {i}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default Carousel;
